const isValidId = value =>
  /^[1-3](19|20)\d{2}[7-8]\d{7}[0-9]\d{2}$/.test(value) ||
  /[a-zA-Z]{2}[0-9]{7}/.test(value) ||
  /[a-zA-Z]{1}[0-9]{7}/.test(value);

export default isValidId;
